import { CONSENT_COOKIE } from "core/config";
import deleteLocalStorageItem from "helpers/deleteLocalStorageItem";
import deleteLocalCookie from "helpers/deleteLocalCookie";
import { IBulkConfig } from "types/config-files/mainConfig";
import { NULL } from "constants/primitives";

const deleteLocalConsent = (bulkConfig: IBulkConfig | null = NULL) => {
  deleteLocalCookie(CONSENT_COOKIE, bulkConfig);
  deleteLocalStorageItem(CONSENT_COOKIE);
};

export default deleteLocalConsent;
